import { render, staticRenderFns } from "./DictateTextInput.vue?vue&type=template&id=605792c8&"
import script from "./DictateTextInput.vue?vue&type=script&lang=js&"
export * from "./DictateTextInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../Projects/register/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports